import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api';

const getAuthHeader = () => {
  const token = localStorage.getItem('auth_token');
  return { Authorization: `Bearer ${token}` };
};

class CourseService {
  /**
   * Ottieni dettagli del corso per ID
   */
  async getCourseById(courseId) {
    try {
      const response = await axios.get(`${API_BASE_URL}/courses/${courseId}`, {
        headers: getAuthHeader()
      });
      return response.data.course || response.data;
    } catch (error) {
      console.error('Errore caricamento corso:', error);
      // Return a mock/fallback object instead of throwing to prevent crash
      return {
        id: courseId,
        title: `Corso #${courseId}`,
        description: "Dettagli corso non disponibili"
      };
    }
  }

  /**
   * Ottieni obiettivi del corso
   */
  async getCourseObjectives(courseId) {
    try {
      const response = await axios.get(`${API_BASE_URL}/courses/${courseId}/objectives`, {
        headers: getAuthHeader()
      });
      return response.data.objectives || [];
    } catch (error) {
      console.error('Errore caricamento obiettivi:', error);
      return [];
    }
  }

  /**
   * Ottieni moduli e lezioni del corso
   */
  async getCourseModules(courseId) {
    try {
      const response = await axios.get(`${API_BASE_URL}/courses/${courseId}/modules`, {
        headers: getAuthHeader()
      });
      return response.data.modules || [];
    } catch (error) {
      console.error('Errore caricamento moduli:', error);
      return [];
    }
  }

  /**
   * Ottieni materiali del corso
   */
  async getCourseMaterials(courseId) {
    try {
      const response = await axios.get(`${API_BASE_URL}/courses/${courseId}/materials`, {
        headers: getAuthHeader()
      });
      return response.data.materials || [];
    } catch (error) {
      console.error('Errore caricamento materiali:', error);
      return [];
    }
  }

  async downloadCourseMaterial(courseId, materialId) {
    return axios.get(`${API_BASE_URL}/courses/${courseId}/materials/${materialId}/download`, {
      headers: getAuthHeader(),
      responseType: 'blob',
    });
  }

  /**
   * Ottieni eventi del corso (Calendario)
   * URL: GET /api/courses/{courseId}/events
   */
  async getCourseEvents(courseId) {
    try {
      const response = await axios.get(`${API_BASE_URL}/courses/${courseId}/events`, {
        headers: getAuthHeader()
      });
      return response.data.events || [];
    } catch (error) {
      console.error('Errore caricamento eventi:', error);
      return [];
    }
  }

  /**
   * Crea un evento nel calendario
   * URL: POST /api/courses/{courseId}/events
   */
  async createCourseEvent(courseId, eventData) {
    try {
      const response = await axios.post(`${API_BASE_URL}/courses/${courseId}/events`, eventData, {
        headers: getAuthHeader()
      });
      return response.data;
    } catch (error) {
      console.error('Errore creazione evento:', error);
      throw error;
    }
  }
}

export default new CourseService();
